export class NotificationFilterForm {
  pageSize = 10;
  pageOffset = 0;
}
